var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KCardGrid',{attrs:{"layout":"1-2-2","skeletonsConfig":_vm.skeletonsConfig,"loading":_vm.loading}},_vm._l((2),function(i){return _c('Card',{key:i,attrs:{"headingLevel":4,"prependTitle":`(${i})`},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('div',{style:({
          marginLeft: '-4px',
          color: 'var(--tokens-annotation)',
        })},[_c('span',{style:({
            display: 'inline-block',
            padding: '4px 8px',
            margin: '4px',
            borderRadius: '4px',
            backgroundColor: 'var(--palette-grey-v100)',
          })},[_c('KIcon',{style:({ fontSize: '13px', position: 'relative', top: '3px' }),attrs:{"icon":"readSolid"}}),_vm._v("\n          Read\n        ")],1),_vm._v(" "),_c('span',{style:({
            display: 'inline-block',
            padding: '4px 8px',
            margin: '4px',
            borderRadius: '4px',
            backgroundColor: 'var(--palette-grey-v100)',
          })},[_vm._v("\n          Short Activity\n        ")]),_vm._v(" "),(_vm.windowBreakpoint > 3)?[_c('span',{style:({
              display: 'inline-block',
              padding: '4px 8px',
              margin: '4px',
              borderRadius: '4px',
              backgroundColor: 'var(--palette-grey-v100)',
            })},[_vm._v("\n            Biology\n          ")]),_vm._v(" "),_c('span',{style:({
              display: 'inline-block',
              padding: '4px 8px',
              margin: '4px',
              borderRadius: '4px',
              backgroundColor: 'var(--palette-grey-v100)',
            })},[_vm._v("\n            Ecology\n          ")])]:_vm._e()],2)]},proxy:true}],null,true)})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }